import Abdication from "./Abdication";
import AllianceActions from "./AllianceActions";
import AllianceInfo from "./AllianceInfo";
import ApplicationActions from "./ApplicationActions";
import ApplyAlliance from "./ApplyAlliance";
import BuildingDetail from "./BuildingDetail";
import ConfirmDialog from "./ConfirmDialog";
import CrimeChoice from "./CrimeChoice";
import DemolishBuilding from "./DemolishBuilding";
import EditNote from "./EditNote";
import ExpandTile from "./ExpandTile";
import FoundAlliance from "./FoundAlliance";
import GeneralInfo from "./GeneralInfo";
import GovernorateInfo from "./GovernorateInfo";
import HelpMenu from "./HelpMenu";
import LeaveAlliance from "./LeaveAlliance";
import MemberActions from "./MemberActions";
import NewBuilding from "./NewBuilding";
import NewTile from "./NewTile";
import PlayersMenu from "./PlayersMenu";
import PurchaseUpgrade from "./PurchaseUpgrade";
import RepairBuilding from "./RepairBuilding";
import SellItem from "./SellItem";
import StatsDialog from "./StatsDialog";
import UpgradeBuilding from "./UpgradeBuilding";

const dialogContents: any = {
  Abdication,
  AllianceActions,
  AllianceInfo,
  ApplicationActions,
  ApplyAlliance,
  BuildingDetail,
  ConfirmDialog,
  CrimeChoice,
  DemolishBuilding,
  EditNote,
  ExpandTile,
  FoundAlliance,
  GeneralInfo,
  GovernorateInfo,
  HelpMenu,
  LeaveAlliance,
  MemberActions,
  NewBuilding,
  NewTile,
  PlayersMenu,
  PurchaseUpgrade,
  RepairBuilding,
  SellItem,
  StatsDialog,
  UpgradeBuilding
};

export default dialogContents;
